// @ts-ignore
import _FlatList from "react-native-web/dist/vendor/react-native/FlatList";
import type { FlatList as IFlatList } from "./__rn-types";

export const FlatList = _FlatList as typeof IFlatList;
